import { useEffect, useRef } from 'react'

import { gaUtils } from '@space-lib/analytics'
import { Sections } from '@space-lib/analytics'
import { System } from '@space-lib/datahub'
import useTranslation from '@space-lib/hooks/useTranslation'
import { AuthStatus, useAuthContext } from '@space-shell/common/contexts/auth'

import { useLocation } from 'react-router-dom'

type SendPageViewParams = {
  pathname: string
  subSection: string
}
type SubSectionOptions = {
  [key: string]: RegExp
}

const subSectionOpts: SubSectionOptions = {
  [Sections.HOME_PRODUCTS as string]: /\/products\/?$/,
  [Sections.CONTENT_CONSUMER as string]: /\/products\//,
  [Sections.COMMUNITY as string]: /\/community\//
}

export const useGoogleAnalyticsPageView = () => {
  const location = useLocation()
  const { authStatus } = useAuthContext()
  const { i18n } = useTranslation()

  const createSubSection = (): string => {
    for (const type in subSectionOpts) {
      if (subSectionOpts[type].test(location?.pathname)) {
        return type
      }
    }

    return Sections.HOME
  }

  const subSectionValue = createSubSection()

  const sendPageView = useRef(({ pathname, subSection }: SendPageViewParams) => {
    try {
      gaUtils.registerPageView({
        isAuthenticated: authStatus === AuthStatus.AUTHENTICATED,
        language: i18n?.language,
        section: System.MEMBERSHIP_CONSUMER,
        pathname: pathname,
        subsection: subSection
      })
    } catch (error) {
      console.error(`useGoogleAnalyticsPageView - Error: ${error}`)
    }
  })

  useEffect(() => {
    sendPageView.current({ pathname: location?.pathname, subSection: subSectionValue })
  }, [i18n?.language, location?.pathname, subSectionValue])
}
